import { createAction } from 'redux-actions';

export const onEditOrders = createAction('ON_EDIT_RESERVATION_ORDERS');

export const clearOrders = createAction('CLEAR_RESERVATION_ORDERS');

export const clearPicklists = createAction('CLEAR_RESERVATION_PICKLISTS');

export const updateItemsSumQuantities = createAction(
  'UPDATE_ITEMS_SUM_QUANTITIES'
);

export const updateItemsInitialSumQuantities = createAction(
  'UPDATE_ITEMS_INITIAL_SUM_QUANTITIES'
);
